<template>
  <div>
    <div class="list-items">
      <div class="row">
        <div
          v-for="vp in items"
          class="col-sm-6 col-md-4 col-lg-4">
          <item-vat-pham :vatpham="vp"/>
        </div>
      </div>
    </div>

    <infinite-loading
      :identifier="infiniteId"
      @infinite="infiniteHandler">
      <div slot="spinner">Đang tìm kiếm...</div>
      <div slot="no-more">Không còn sản phẩm nào!</div>
      <div slot="no-results">Không có sản phẩm nào phù hợp</div>
    </infinite-loading>
  </div>
</template>

<script>
  import rating from '../include/rating'
  import ItemVatPham from './ItemVatPham'
  import rf from '../../communicate/RequestFactory'
  import InfiniteLoading from "vue-infinite-loading";

  export default {
    name: 'ItemLists',
    components: {
      ItemVatPham,
      rating: rating,
      InfiniteLoading
    },
    data() {
      return {
        items: [],
        errors: [],
        limit: 10,
        page: 1,
        infiniteId: +new Date(),
      }
    },

    mounted() {
      this.infiniteId += 1;
    },

    methods: {
      infiniteHandler($state) {
        this.$Progress.start();
        const data = {
          page: this.page,
          limit: this.limit
        };
        rf.getRequest('ItemRequest').getItems(data).then((res) => {
          if (res.data && res.data.length) {
            this.page += 1;
            this.items.push(...res.data);
            $state.loaded();
          } else {
            $state.complete();
          }
          this.$Progress.finish()
        }).catch(err => {
          this.errors.push(err.message);
          $state.complete();
          this.$Progress.fail();
        })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/item/ItemLists.vue